import { useEffect, useState } from "react";
import dummyImage from "../../assets/images/dummy-image.jpg";
import ParkImagesModal from "./ParkImagesModal";
import "../../assets/css/park-image.css"

const getGridStructure = (imageCount) => {
    if (imageCount === 0) return [[[0]]];
    if (imageCount === 1) return [[[0]]];
    if (imageCount === 2) return [[[0]], [[1]]];
    if (imageCount === 3) return [[[0]], [[1], [2]]];
    if (imageCount === 4) return [[[0]], [[1], [2, 3]]];
    if (imageCount === 5) return [
        [[0]],
        [
            [1, 2],
            [3, 4],
        ],
    ];

    return [
        [[0]],
        [
            [1, 2],
            [3, 4],
        ],
    ];

};

export default function ParkImages({ rides = [], logo = dummyImage, name = 'dummy-park' }) {
    const [activeImageIndex, setActiveImageIndex] = useState(0);
    const [openModal, setOpenModal] = useState(false);

    const [images, setImages] = useState([{
        image: logo,
        alt: name
    }]);

    useEffect(() => {
        if(rides.length) {
            const defaultImage = {
                image: logo,
                alt: name
            }
            const imagesList = rides.map(ride => ({
                image: ride.logo,
                alt: ride.name
            }))

            setImages([defaultImage, ...imagesList])
        }
    }, [rides, logo, name]);

    const gridStructure = getGridStructure(images?.length || 0);

    if (images.length === 0 || rides.length === 0) return <div />

    return <div style={{ display: images.length ? 'block' : 'none' }}>
        <div className="container-fluid d-none d-sm-flex flex-row gap-2 gallery-wrapper mb-5 mt-3 p-0">
            {gridStructure.map((firstLayer) => (
                <div key={firstLayer} className="firstLayerStyle">
                    {firstLayer.map((secondLayer) => (
                        <div key={secondLayer} className="secondLayerStyle">
                            {secondLayer.map((photosIndex) => (
                                <button
                                    type="button"
                                    key={photosIndex}
                                    className="gallery-item"
                                    onClick={() => {
                                        setActiveImageIndex(photosIndex);
                                        setOpenModal(true);
                                    }}
                                >
                                    <img
                                        src={images[photosIndex].image || ""}
                                        alt={images[photosIndex].alt || ""}
                                        className="gallery-img"
                                    />
                                    <span
                                        className={`centered-text-in-image ${(images?.length || 0) - 5 > 0 &&
                                            photosIndex === 4
                                            ? "d-block"
                                            : "d-none"
                                            }`}
                                    >
                                        {(images?.length || 0) - 4}+
                                    </span>
                                </button>
                            ))}
                        </div>
                    ))}
                </div>
            ))}
        </div>
        <div className="d-block d-sm-none bg-light-custom">
            <button
                type="button"
                className="mobile-gallery-box w-100 position-relative border-0 p-0"
                onClick={() => {
                    setActiveImageIndex(0);
                    setOpenModal(true);
                }}
            >
                <img
                    src={images[0].image || ""}
                    alt={images[0].alt || ""}
                    className="gallery-img"
                />
            </button>
        </div>
        {openModal && <ParkImagesModal open={openModal} activeImageIndex={activeImageIndex} handleClose={() => setOpenModal(false)} images={images} />}
    </div>
}